import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  ApiDependencyProviderService,
  CollectionRequest,
  CollectionResponse,
} from '@web/common';
import { valueOrDefault } from '@web/utils';
import { PublicShippingMethodCollectionItemResponse } from '@web/shared/module/shop';

@Injectable({
  providedIn: 'root',
})
export class PublicShippingMethodApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  public fetchCollection(options: {
    cacheable?: boolean;
    request: CollectionRequest;
  }): Observable<
    CollectionResponse<PublicShippingMethodCollectionItemResponse>
  > {
    const path = `shipping/method`;
    const url = this.provider.httpUrlFactory.withQueryParams(
      this.hostUrl(),
      path,
      this.provider.httpHelper.collectionRequestToQueryParams(options.request),
    );
    const context = this.provider.httpContextBuilder
      .skipByLoadingInterceptor()
      .skipByHttpErrorInterceptor()
      .withOptionalCacheInterceptor(() =>
        valueOrDefault(options?.cacheable, false),
      )
      .build();

    return this.provider.http
      .get(url, { context })
      .pipe(
        map(
          this.provider.httpHelper.bodyToCollectionResponse(
            PublicShippingMethodCollectionItemResponse,
          ),
        ),
      );
  }

  private hostUrl(): string {
    return this.provider.environment.ApiHostUrl.Shop;
  }
}
